import React from 'react'
import styled from 'styled-components'
import { FaLeaf } from "react-icons/fa";
import strawberryImage from '../assets/hero-image.jpg'

const About = () => {
    return (
        <div className='container'>
            <h1 className='section-title' id='about'>Hvem Er Vi</h1>
            <div className='section-border'></div>
            <Section>
                <LeftSide>
                    <p>
                        Hos oss er vi lidenskapelig opptatt av å bringe sommerens smak til ditt bord! 
                        Vi selger håndplukkede, kvalitetsbær fra Norge og utlandet i sommersesongen. 
                        Vårt utvalg inkluderer de fineste norske jordbærene i mange sorter, saftige norske bringebær og smakfulle moreller fra Norge, Tyrkia og Belgia.
                    </p>
                    <p>
                        Vi leverer bær som er plukket på toppen av sin modenhet for å sikre maksimal smak og kvalitet. 
                        Enten du spiser dem rett fra esken, baker en kake eller lager syltetøy, vil våre bær bringe glede til hver eneste bit.
                    </p>

                    <div className='points-list'>
                        <div className='point'>
                            <FaLeaf size={20} color='#2d6a4f' />
                            <span>
                                Ferske, smakfulle bær
                                <p>
                                    Plukket på rett tid for best mulig kvalitet
                                </p>
                            </span>
                        </div>

                        <div className='point'>
                            <FaLeaf size={20} color='#2d6a4f' /> 
                            <span>
                                Stort utvalg
                                <p>
                                    Mange sorter norske jordbær, bringebær og moreller fra Norge, Tyrkia og Belgia
                                </p>
                            </span>  
                        </div>
                        
                        <div className='point'>
                            <FaLeaf size={20} color='#2d6a4f' />  
                            <span>
                                Levering
                                <p>
                                    Vi leverer i Oslo og omegn
                                </p>
                            </span>
                        </div>
                       
                        
                        <div className='point'>
                            <FaLeaf size={20} color='#2d6a4f' /> 
                            <span>
                                Miljøvennlig
                                <p>
                                    Vi bruker bærekraftig emballasje og jobber for å redusere matsvinn
                                </p>
                            </span>  
                        </div>
                        
                        
                        <div className='point'>
                            <FaLeaf size={20} color='#2d6a4f' /> 
                            <span>
                                Lokalt fokus
                                <p>
                                    Støtter norske bønder og lokale samfunn
                                </p>
                            </span>  
                        </div>
                        
                    </div>
                </LeftSide>
                
                <RightSide>
                    <img src={strawberryImage} alt="Fresh Strawberries" />
                </RightSide>
            </Section>
        </div>
    )
}

export default About

const Section = styled.section`
    display: flex;
    width: 100%;
    gap: 3rem;

    @media (max-width: 1024px) {
        gap: 2rem;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 1.5rem;
        align-items: center;
        justify-content: center;
    }
    
`;

const LeftSide = styled.div`
    flex: 1;
    p {
        margin-bottom: 1.1rem;
    }

    .points-list {
        p {
            font-size: 12px;
            color: #807d7d;
            margin: 0;
            font-weight: normal;
        }
        span {
            display: flex;
            flex-direction: column;
            gap: 0.2rem;
            color: #b31a1a;
            font-weight: bold;
            font-size: 14px;
        }

        .point {
            display: flex;
            gap: .4rem;
            align-items: center;
            margin-bottom: 1.2rem;
        }
    }

    @media (max-width: 768px) {
        p {
            font-size: 12px;
        }
    }
`;

const RightSide = styled.div`
    flex: 1;
    img {
        width: 100%;
        height: 100%;
        border-radius: 10px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        object-fit: cover;
    }

    @media (max-width: 768px) {
        img {
            max-width: 100%;
        }
    }
`;